import { observable, action, toJS } from "mobx";
import { WeaLocaleProvider } from "ecCom";
import WeaForm from "../../wea-form";
import WeaTableNew from "../../wea-table-new";
const { TableStore } = WeaTableNew;
const getLabel = WeaLocaleProvider.getLabel;
import Apis from "../apis/Api";
const getCondition = {
  datas: () => {
    return [
      {
        title: getLabel("81711", "基本信息"),
        defaultshow: true,
        items: [
          {
            colSpan: 2,
            conditionType: "BROWSER",
            domkey: ["operator"],
            fieldcol: 16,
            label: getLabel("99", "操作者"),
            labelcol: 8,
            browserConditionParam: {
              type: "1",
              title: getLabel("99", "操作者")
            }
          },
          {
            colSpan: 2,
            conditionType: "DATE",
            domkey: ["operateTime"],
            fieldcol: 16,
            label: getLabel("18008", "操作时间"),
            labelcol: 8,
            browserConditionParam: {
              type: "1",
              title: getLabel("18008", "操作时间")
            }
          },
          {
            colSpan: 2,
            conditionType: "BROWSER",
            domkey: ["operatorDepart"],
            fieldcol: 16,
            label: getLabel("385898", "操作者部门"),
            labelcol: 8,
            browserConditionParam: {
              type: "4",
              title: getLabel("385898", "操作者部门")
            }
          },
          {
            colSpan: 2,
            conditionType: "BROWSER",
            domkey: ["operatorSubcompany"],
            fieldcol: 16,
            label: getLabel("385899", "操作者分部"),
            labelcol: 8,
            browserConditionParam: {
              type: "164",
              title: getLabel("385899", "操作者分部")
            }
          },
          {
            colSpan: 2,
            conditionType: "INPUT",
            domkey: ["targetName"],
            fieldcol: 16,
            label: getLabel("106", "对象"),
            labelcol: 8
          }
        ]
      }
    ];
  }
};
export default class LogStore {
  @observable
  advanceShow = false;
  @observable
  form = new WeaForm();
  @observable
  tableStore = new TableStore();
  @observable
  logType;
  @observable
  logSmallType;
  @observable
  targetId;
  @observable
  detailVisible = false;
  @observable
  detailRecord = {};
  @observable
  showParams = false;
  @observable
  detailKey = `${new Date().getTime()}`;
  @observable
  detailTitle = "";
  @observable
  conditions = getCondition.datas();
  @observable
  viewdetailColums = [];
  @observable
  viewdetailDatas = [];
  @observable
  viewdetailTitles = [];

  @action
  update = object => {
    if (Object.prototype.toString.call(object) === "[object Object]") {
      for (const key in object) {
        if (object.hasOwnProperty(key)) {
          this[key] = object[key];
        }
      }
    }
    return this;
  };

  initForm = () => {
    this.form.initFormFields(toJS(this.conditions));
    this.form.reset();
  };

  getDatas = (params = {}) => {
    let ps = { ...params, ...this.form.getFormParams() };
    if (ps.operateTime) {
      let timeArray = ps.operateTime;
      timeArray.length > 0 && (ps.operateTime = timeArray[0]);
      timeArray.length > 1 && (ps.startDate = timeArray[1]);
      timeArray.length > 2 && (ps.endDate = timeArray[2]);
    }
    ps.logType = this.logType;
    ps.logSmallType = this.logSmallType;
    if (!ps.targetId) {
      ps.targetId = this.targetId;
    }

    Apis.logView(ps).then(result => {
      this.tableStore.getDatas(result.sessionkey, 1);
    });
  };

  getDetailTable() {
    this.viewdetailColums = [];
    this.viewdetailDatas = [];
    this.viewdetailTitles = [];
    this.detailRecord.mainId &&
      Apis.viewDetail({ belongMainId: this.detailRecord.mainId }).then(
        result => {
          this.viewdetailColums = result.columns;
          this.viewdetailDatas = result.data;
          this.viewdetailTitles = result.title;
        }
      );
  }

  setDetailVisible(bool) {
    this.detailVisible = bool;
  }

  setDetailTitle(name = "") {
    this.detailTitle = name;
  }

  setDetailRecord(obj = {}) {
    this.detailRecord = { ...obj };
  }

  setShowParams(bool = false) {
    this.showParams = bool;
  }

  updateDetailkey(key = "") {
    this.detailKey = key;
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-log-view/stores/LogStore.js